import script from "./KickbackBox.vue?vue&type=script&setup=true&lang=js"
export * from "./KickbackBox.vue?vue&type=script&setup=true&lang=js"

import "./KickbackBox.vue?vue&type=style&index=0&id=f550b920&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f550b920"]])

export default __exports__